"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3568],{

/***/ 61835:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/brake-icon-black.72841916.png","height":104,"width":104,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAJFBMVEUAAAAAAAAAAAAAAAAAAAAAAABMaXEAAAAAAAAAAAAAAAAAAABjcfp2AAAADHRSTlMklEMUPVwANXSHLgifTpxgAAAACXBIWXMAAAsTAAALEwEAmpwYAAAANklEQVR4nAXBhwEAMAjDMEPY/f/fStQjJ1U8x4kRoR7rSAKz3UvabXYyca1ZA3dy5EVd0PHqAyrHATHF+85eAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":8});

/***/ }),

/***/ 13158:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/clock-icon-black.8593e169.png","height":102,"width":102,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAGFBMVEUAAAAAAABMaXEAAAAAAAAAAAAAAAAAAACTHuQbAAAACHRSTlMdgwB4LkMM2tiHsmgAAAAJcEhZcwAACxMAAAsTAQCanBgAAAAzSURBVHicLcvBDQAwDMJAAyHdf+OqUn9+nPFEypjRwmoIbk0QTo0Q230RbHvy8Slvx+UCFpcAovYVFYEAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":8});

/***/ }),

/***/ 38177:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/document-icon-black.6c5dbd61.png","height":100,"width":100,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAHlBMVEUAAAAAAAAZGx5MaXEAAAAICAoAAAAAAAAAAAAqLjNy/OB4AAAACnRSTlN1SSYATTIUZEVxfGYjswAAAAlwSFlzAAALEwAACxMBAJqcGAAAADZJREFUeJwVyrkRwEAMA7GlSD3Xf8MeZwiABSDTzGzRKHZYIblmflwxTsjVe6XQVPeffexy/gAa8ADZ0apvBQAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":8});

/***/ }),

/***/ 32997:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/google-logo-icon.b6a61d5c.png","height":100,"width":100,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAYFBMVEVMaXEzqFL9wQPpRDgyqEtAh/DqQzSwcC5AhfUyqFNBkvjzuQlAjdZDh/PnQjXTTFHJtxrqQjTpQDf5nBJGjvzuRzzqPDcpplj/HwBEhPVHj/88sH85tllfu0z/YjL8STnuslihAAAAGnRSTlMA4qfkWluuBrOoEeufRGA1VlidVX/3e3YYzvaoMGsAAAAJcEhZcwAACxMAAAsTAQCanBgAAABASURBVHicJcZFAoAwDADBLZUkuEux//+SA3MakCGlVoDx9X7pYHpWZAeKilJV458jz/T3BjE3YJdzZw1IMAvCB1t2Anv9m9fyAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":8});

/***/ }),

/***/ 29001:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/like-shaped-icon-black.fde2bee1.png","height":100,"width":100,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAJ1BMVEUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADdEvm1AAAADXRSTlMBFGh4YoQ9mEAjLkZF1R7ZDgAAAAlwSFlzAAALEwAACxMBAJqcGAAAADdJREFUeJwVy7cRwEAQA7EleeZl+q9XI+QAZAugMqcLFFVo4bPbnqKezZ0plNe5InDPtP8ml+ADHSkA1J54/2wAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":8});

/***/ }),

/***/ 82705:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/receipt-discount-icon-black.beb5dd68.png","height":100,"width":100,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAALVBMVEUAAAAAAABMaXEAAAAAAAAjKCwAAAAEBAQAAAAkJi0AAAAAAAAtMTgAAAAAAAAGRdQ6AAAAD3RSTlMyIgBhWxx9D491S3RaBS5M/0jYAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAOUlEQVR4nCXIxw3AMBADMElXXfcf1wjCJ6GZa+UUmBUVScCCOxyAaQwZAI9N/nPON+w27yZ0y72uHiwbATncGi31AAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":8});

/***/ }),

/***/ 80734:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/shield-tick-icon-black.e9703e42.png","height":102,"width":102,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAGFBMVEUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABWNxwqAAAACHRSTlMDOXYaimUqW6ySz/wAAAAJcEhZcwAACxMAAAsTAQCanBgAAAAxSURBVHicHYvJDQAgEISYY9f+Ozb6IwQA2QLwbMaggTBCB5XzoftM+sIG1N3+LXbgAhLfAIjtnVJmAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":8});

/***/ }),

/***/ 85604:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/vioc-logo.f45fde1d.png","height":984,"width":1080,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAHCAMAAAACh/xsAAAATlBMVEXxh4LolJDnbWfnVE30Y1z0Vk36kIn29PTwb2jpoZ3yenT8gnnq9/sAf8Wth5IjruIlZp/Z4udZsdjn3t6wLDjqCgCLxd6Jxd5hSnB4zetAk6nbAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAPElEQVR4nB3BBw7AMAgDQIcQDBnd8/8frdQ77BHs172Cfto7NoIsx5g7ESbPMrVAVlRrJUOKa3UVJPzSB03DAeg68BtgAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":7});

/***/ }),

/***/ 43568:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "S": function() { return /* binding */ ViocIndexPageTemplate; },
  "Z": function() { return /* binding */ components_ViocPage; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./src/components/utils/string-utils.ts
var string_utils = __webpack_require__(2638);
// EXTERNAL MODULE: ./src/components/SEMPage/CityPhoneNumberData.tsx
var CityPhoneNumberData = __webpack_require__(21611);
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-duotone-svg-icons/faCalendarCheck.js
var faCalendarCheck = __webpack_require__(52375);
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-duotone-svg-icons/faCarMechanic.js
var faCarMechanic = __webpack_require__(67170);
// EXTERNAL MODULE: ./src/components/Layout.tsx + 1 modules
var Layout = __webpack_require__(22932);
// EXTERNAL MODULE: ./node_modules/@fortawesome/react-fontawesome/index.es.js
var index_es = __webpack_require__(67814);
// EXTERNAL MODULE: ./src/components/Container.tsx
var Container = __webpack_require__(3210);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./src/components/Button.tsx
var Button = __webpack_require__(68663);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/@fortawesome/free-solid-svg-icons/faSpinner.js
var faSpinner = __webpack_require__(92332);
;// CONCATENATED MODULE: ./src/components/ViocPage/CtaButton.tsx










var InnerButton = function(props) {
    var buttonText = props.buttonText, className = props.className, onClick = props.onClick, isLoading = props.isLoading, rest = (0,_object_without_properties/* default */.Z)(props, [
        "buttonText",
        "className",
        "onClick",
        "isLoading"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.zx, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        onClick: onClick,
        className: classnames_default()(className),
        style: {
            paddingTop: 8,
            paddingBottom: 8,
            paddingLeft: 25,
            paddingRight: 25
        }
    }, rest), {
        children: isLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
            icon: faSpinner/* faSpinner */.LM,
            spin: true
        }) : buttonText
    }));
};
function CtaButton(props) {
    var buttonText = props.buttonText, className = props.className, href = props.href, isLoading = props.isLoading, rest = (0,_object_without_properties/* default */.Z)(props, [
        "buttonText",
        "className",
        "href",
        "isLoading"
    ]);
    if (!href) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(InnerButton, (0,_object_spread/* default */.Z)({
            buttonText: buttonText,
            className: className,
            isLoading: isLoading
        }, rest));
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        href: href,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InnerButton, (0,_object_spread/* default */.Z)({
                buttonText: buttonText,
                className: className,
                isLoading: isLoading
            }, rest))
        })
    });
}

;// CONCATENATED MODULE: ./src/components/ViocPage/ServicesHowItWorksSection.tsx







var ServicesHowItWorksSection = function(param) {
    var title = param.title, description = param.description, steps = param.steps, buttonText = param.buttonText;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: "xl:py-20 text-center",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* Container */.W, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                            className: "title text-2xl sm:text-3xl md:text-4xl",
                            children: title
                        }),
                        description ? /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "description",
                            children: description
                        }) : null
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "mt-6 mb-6 grid md:grid-cols-3 gap-4",
                    children: steps.map(function(value, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(HowItWorksStep, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, value), {
                            number: index + 1,
                            stepImage: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                size: "3x",
                                color: "#ea3616",
                                icon: value.image
                            })
                        }), index);
                    })
                }),
                buttonText && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "pt-5",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CtaButton, {
                        buttonText: buttonText,
                        href: "#"
                    })
                })
            ]
        })
    });
};
var HowItWorksStep = function(param) {
    var title = param.title, description = param.description, stepImage = param.stepImage, number = param.number;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "py-4 flex bg-[#FAFAFA] flex-grow-1 flex-col h-100 text-left px-6",
        style: {
            border: "1px solid #dddddd"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-row mb-2",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "mr-auto mt-6",
                        children: stepImage
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "text-black opacity-10 text-[64px]",
                        style: {
                            fontFamily: "IndustryInc-Base",
                            lineHeight: "64px"
                        },
                        children: number
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "mt-3",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                        className: "text-xl md:text-2xl",
                        children: title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "description",
                        children: description
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-duotone-svg-icons/faShieldCheck.js
var faShieldCheck = __webpack_require__(68481);
;// CONCATENATED MODULE: ./src/components/ViocPage/HappinessGuaranteeSection.tsx





var HappinessGuaranteeSection = function(param) {
    var description = param.description, title = param.title;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: "xl:py-20 text-center",
        style: {
            backgroundColor: "white"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* Container */.W, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                    icon: faShieldCheck/* faShieldCheck */.ip,
                    color: "#f04f23",
                    size: "7x"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                    className: "py-4 title text-2xl sm:text-3xl md:text-4xl",
                    children: title
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "description",
                    children: description
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./src/components/Forms/ScheduleServiceMultiStep/NoEmailScheduleServiceFormMultiStep.tsx + 2 modules
var NoEmailScheduleServiceFormMultiStep = __webpack_require__(42786);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/react-star-rating-component/index.js
var react_star_rating_component = __webpack_require__(64396);
var react_star_rating_component_default = /*#__PURE__*/__webpack_require__.n(react_star_rating_component);
// EXTERNAL MODULE: ./node_modules/@fortawesome/free-solid-svg-icons/index.mjs
var free_solid_svg_icons = __webpack_require__(59417);
;// CONCATENATED MODULE: ./src/components/ViocPage/StarsAndRatings.tsx




var StarsAndRatings = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
        className: "mt-1",
        style: {
            lineHeight: 1
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((react_star_rating_component_default()), {
            name: "rating",
            value: 5,
            starCount: 5,
            starColor: "gold",
            editing: false,
            renderStarIcon: function(index, value) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    children: index <= value ? /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                        icon: free_solid_svg_icons/* faStar */.Tab,
                        color: "gold"
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                        icon: free_solid_svg_icons/* faStar */.Tab,
                        color: "gold"
                    })
                });
            },
            renderStarIconHalf: function() {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                        icon: free_solid_svg_icons/* faStarHalf */.eJY,
                        color: "gold"
                    })
                });
            }
        })
    });
};

// EXTERNAL MODULE: ./node_modules/@sentry/minimal/esm/index.js + 1 modules
var esm = __webpack_require__(40802);
// EXTERNAL MODULE: ./public/img/icons/google-logo-icon.png
var google_logo_icon = __webpack_require__(32997);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(87536);
// EXTERNAL MODULE: ./node_modules/yup/es/index.js + 25 modules
var es = __webpack_require__(74231);
// EXTERNAL MODULE: ./node_modules/@hookform/resolvers/yup/dist/yup.mjs + 1 modules
var yup = __webpack_require__(47533);
;// CONCATENATED MODULE: ./public/img/nubrakes-van.png
/* harmony default export */ var nubrakes_van = ({"src":"/_next/static/media/nubrakes-van.5fa42bbf.png","height":750,"width":1336,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAMAAACEE47CAAAASFBMVEVKZCC4YFGIdWt9REFYNTKWmXdeYWUhMUI2RylPQFmdnVhhaUBncHimf3Dk2aY4TU9RTlCru8DKaVRfcTeDU2ezsZd6jWr89tDWMJjWAAAACXBIWXMAAAsTAAALEwEAmpwYAAAALElEQVR4nGNgYOAWE2YV5WLg4ODnYeIVYGNg5xRhFGJkFWRg52RmYWHjEwcAFrgBPaOR43IAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":4});
// EXTERNAL MODULE: ./public/img/vioc-logo.png
var vioc_logo = __webpack_require__(85604);
// EXTERNAL MODULE: ./src/components/GraySection.tsx
var GraySection = __webpack_require__(18737);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/graphql-tag/lib/index.js + 14 modules
var lib = __webpack_require__(59397);
// EXTERNAL MODULE: ./node_modules/query-string/index.js + 4 modules
var query_string = __webpack_require__(54887);
// EXTERNAL MODULE: ./src/components/clients/new-backend.client.ts
var new_backend_client = __webpack_require__(36826);
// EXTERNAL MODULE: ./node_modules/js-cookie/dist/js.cookie.mjs
var js_cookie = __webpack_require__(31955);
;// CONCATENATED MODULE: ./src/components/ViocPage/createViocLead.tsx



function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      mutation createViocLead($createViocLeadInput: CreateViocLeadInput!) {\n        createViocLead(createViocLeadInput: $createViocLeadInput) {\n          id\n        }\n      }\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var createViocLead = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(input) {
        var ref, ref1, ref2, campaignUrl, campaignQueryParams, ref3;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    campaignUrl = (ref2 = js_cookie/* default */.Z === null || js_cookie/* default */.Z === void 0 ? void 0 : js_cookie/* default.get */.Z.get("__gtm_campaign_url")) !== null && ref2 !== void 0 ? ref2 : null;
                    campaignQueryParams = campaignUrl ? (ref = query_string/* default */.Z === null || query_string/* default */.Z === void 0 ? void 0 : query_string/* default.parseUrl */.Z.parseUrl(campaignUrl)) === null || ref === void 0 ? void 0 : ref.query : null;
                    return [
                        4,
                        new_backend_client/* newBackendClient.mutate */.t.mutate({
                            variables: {
                                createViocLeadInput: {
                                    phoneNumber: input.phoneNumber,
                                    extraFields: input.extraFields,
                                    windowUrl: (ref3 = window === null || window === void 0 ? void 0 : (ref1 = window.location) === null || ref1 === void 0 ? void 0 : ref1.href) !== null && ref3 !== void 0 ? ref3 : null,
                                    queryParams: campaignQueryParams
                                }
                            },
                            mutation: (0,lib/* default */.ZP)(_templateObject())
                        })
                    ];
                case 1:
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    });
    return function createViocLead(input) {
        return _ref.apply(this, arguments);
    };
}();

// EXTERNAL MODULE: ./src/components/Fields/LeadExtraFields.tsx
var LeadExtraFields = __webpack_require__(34818);
// EXTERNAL MODULE: ./src/hooks/useQueryParam.tsx
var useQueryParam = __webpack_require__(73401);
// EXTERNAL MODULE: ./src/pages/_app.tsx
var _app = __webpack_require__(12957);
// EXTERNAL MODULE: ./src/util/util.tsx
var util = __webpack_require__(6069);
;// CONCATENATED MODULE: ./src/lib/viocExperiment.ts
/**
 * VIOC booking-flow A/B experiment — main-site side.
 *
 * This repo's only job in the experiment is to bucket a visitor on the VIOC
 * landing page (`/vioc/`) and carry that assignment to the customer webapp via
 * `?uiv=` on the CTA. The customer webapp is the last gate and decides what
 * actually renders.
 *
 * Assignment must ONLY happen while the experiment is live. When the customer
 * webapp is in `preview` mode it demos a variant using a hand-typed `?uiv=`, and
 * it can only tell a hand-typed param from a real bucketed user if this repo is
 * NOT emitting `?uiv=`. So both halves flip together:
 *
 *   preview / demoing → VIOC_EXPERIMENT_ASSIGNMENT_ENABLED = false (this repo
 *                       assigns nothing; customer webapp honours hand-typed uiv)
 *   running / live    → VIOC_EXPERIMENT_ASSIGNMENT_ENABLED = true  (this repo
 *                       buckets users; customer webapp mode = 'running')
 */ var VIOC_EXPERIMENT_COOKIE = "exp_vioc_booking_flow";
var VIOC_VARIANTS = (/* unused pure expression or super */ null && ([
    "1",
    "2"
]));
var VIOC_EXPERIMENT_ASSIGNMENT_ENABLED = true;

;// CONCATENATED MODULE: ./src/components/ViocPage/HeaderSection.tsx


























var phoneToInts = function(maskedPhone) {
    return maskedPhone.replace(/\D/g, "");
};
var schema = es/* object */.Ry({
    phoneNumber: es/* string */.Z_().notRequired()
}).required();
var defaultHeaderCopy = {
    subtitle: "Preferred Brake Partner",
    bullets: [
        "We come to you — or meet at Valvoline",
        "Free Brake Inspection ($79 Value)",
        "Completed in 20 minutes", 
    ],
    placeholder: "Enter your Phone Number here",
    scheduleButton: "SCHEDULE INSPECTION",
    errorMessage: "Something went wrong. Please try again.",
    reviewsLabel: "(14,270 reviews)"
};
var goToLink = function(link) {
    return window["location"].assign(link);
};
var VIOC_LEAD_FORM_URL = "".concat(_app.CUSTOMER_WEBAPP_URL.includes("localhost") ? "http" : "https", "://").concat(_app.CUSTOMER_WEBAPP_URL, "/vioc/initial-details");
var HeaderSection = function(param) {
    var title = param.title, _subtitle = param.subtitle, subtitle = _subtitle === void 0 ? defaultHeaderCopy.subtitle : _subtitle, _bullets = param.bullets, bullets = _bullets === void 0 ? defaultHeaderCopy.bullets : _bullets, _scheduleButton = param.scheduleButton, scheduleButton = _scheduleButton === void 0 ? defaultHeaderCopy.scheduleButton : _scheduleButton, tmp = param.errorMessage, errorMessageProp = tmp === void 0 ? defaultHeaderCopy.errorMessage : tmp, _reviewsLabel = param.reviewsLabel, reviewsLabel = _reviewsLabel === void 0 ? defaultHeaderCopy.reviewsLabel : _reviewsLabel;
    var query = (0,useQueryParam/* useQueryParam */.W)();
    var ref = (0,_sliced_to_array/* default */.Z)(react.useState(null), 2), errorMessage = ref[0], setErrorMessage = ref[1];
    var handleSubmit = (0,index_esm/* useForm */.cI)({
        resolver: (0,yup/* yupResolver */.X)(schema)
    }).handleSubmit;
    var ref1 = (0,_sliced_to_array/* default */.Z)(react.useState(false), 2), setIsLoading = ref1[1];
    // const onFormValidationSuccess = async (data: FormData) => {
    //   setIsLoading(true)
    //   setErrorMessage(null)
    //   try {
    //     const phoneInts = phoneToInts(data?.phoneNumber)
    //     await createViocLead({
    //       phoneNumber: phoneInts,
    //       extraFields: getExtraHiddenFieldValues(),
    //     })
    //     goToLink(
    //       serializeLinkWithParams(VIOC_LEAD_FORM_URL, {
    //         ...query,
    //         phoneNumber: phoneInts,
    //       })
    //     )
    //   } catch (e) {
    //     setErrorMessage(errorMessageProp)
    //     Sentry.captureException(e, {
    //       extra: {
    //         phoneNumber: data?.phoneNumber,
    //       },
    //       tags: {
    //         fn: 'createViocLead',
    //       },
    //     })
    //   } finally {
    //     setIsLoading(false)
    //   }
    // }
    var onFormValidationSuccess = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var ref, uiv, e;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setIsLoading(true);
                        setErrorMessage(null);
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            4,
                            5
                        ]);
                        return [
                            4,
                            createViocLead({
                                extraFields: (0,LeadExtraFields/* getExtraHiddenFieldValues */.o)()
                            })
                        ];
                    case 2:
                        _state.sent();
                        uiv = VIOC_EXPERIMENT_ASSIGNMENT_ENABLED ? (ref = document.cookie.split("; ").find(function(row) {
                            return row.startsWith("".concat(VIOC_EXPERIMENT_COOKIE, "="));
                        })) === null || ref === void 0 ? void 0 : ref.split("=")[1] : undefined;
                        goToLink((0,util/* serializeLinkWithParams */.xN)(VIOC_LEAD_FORM_URL, (0,_object_spread/* default */.Z)({}, query, uiv && {
                            uiv: uiv
                        })));
                        return [
                            3,
                            5
                        ];
                    case 3:
                        e = _state.sent();
                        setErrorMessage(errorMessageProp);
                        esm/* captureException */.Tb(e, {
                            tags: {
                                fn: "createViocLead"
                            }
                        });
                        return [
                            3,
                            5
                        ];
                    case 4:
                        setIsLoading(false);
                        return [
                            7
                        ];
                    case 5:
                        return [
                            2
                        ];
                }
            });
        });
        return function onFormValidationSuccess() {
            return _ref.apply(this, arguments);
        };
    }();
    var onSubmitForm = function() {
        handleSubmit(onFormValidationSuccess, function(errors) {
            console.error(errors);
        })();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(GraySection/* GraySection */.g, {
        className: "py-0 text-white",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "py-6 lg:py-12 flex flex-col justify-center items-center relative w-full h-full ",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        id: "overlay",
                        style: {
                            minHeight: "100%",
                            width: "100%",
                            position: "absolute",
                            zIndex: 1,
                            backgroundColor: "rgba(0,0,0,.75)"
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: nubrakes_van,
                        placeholder: "blur",
                        layout: "fill",
                        objectFit: "cover",
                        objectPosition: "bottom center",
                        priority: true,
                        alt: "NuBrakes Mobile Repair Header Image"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        style: {
                            zIndex: 2
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* Container */.W, {
                            className: "text-center",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex flex-col items-center",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        src: vioc_logo/* default */.Z,
                                        objectPosition: "bottom center",
                                        height: 62,
                                        width: 70,
                                        priority: true,
                                        alt: "NuBrakes Mobile Repair Header Image"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                        className: "text-lg mt-2 text-[#FFFFFF] opacity-50 mb-4",
                                        children: subtitle
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "text-center flex flex-col justify-center items-center",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                                className: "text-2xl mt-4 md:mt-0 px-4 md:px-0 sm:text-2xl md:text-4xl text-white sm:mb-0",
                                                children: title
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "list-none flex py-4 flex-wrap gap-x-4 max-w-[36rem] justify-center items-center",
                                                children: bullets.map(function(item) {
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "text-white flex flex-row justify-center items-center",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                                                icon: free_solid_svg_icons/* faCheckCircle */.f8k,
                                                                size: "1x",
                                                                color: "#14d90d",
                                                                style: {
                                                                    borderRadius: "100%",
                                                                    backgroundColor: "white"
                                                                }
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                className: "ml-2 mt-1",
                                                                children: item
                                                            })
                                                        ]
                                                    }, item);
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* Container */.W, {
                        className: "z-[2] w-full max-w-[36rem] text-center -mb-[160px]",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "flex flex-col items-center justify-center shadow-lg bg-white rounded-md",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                style: {
                                    zIndex: 2
                                },
                                className: "flex flex-col p-4 pb-6 max-w-[36rem] w-full",
                                children: [
                                    errorMessage ? /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "text-red-500",
                                        children: errorMessage
                                    }) : null,
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CtaButton, {
                                        //isLoading={isSubmitting || isLoading}
                                        //disabled={isSubmitting || isLoading}
                                        onClick: onSubmitForm,
                                        buttonText: scheduleButton,
                                        className: "w-full mt-4"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex mt-4 justify-center items-center text-black flex-wrap",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "mr-3",
                                                style: {
                                                    fontFamily: "IndustryInc-Base"
                                                },
                                                children: "4.9"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StarsAndRatings, {}),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "flex ml-3 items-center",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        children: reviewsLabel
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "ml-2 flex items-center justify-center w-5 h-5 rounded-full",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                            src: google_logo_icon/* default */.Z,
                                                            objectPosition: "bottom center",
                                                            priority: true,
                                                            alt: "Valvoline logo"
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "h-[140px]"
            })
        ]
    });
};
/* harmony default export */ var ViocPage_HeaderSection = (HeaderSection);

// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-duotone-svg-icons/faMoneyCheckEditAlt.js
var faMoneyCheckEditAlt = __webpack_require__(38510);
;// CONCATENATED MODULE: ./public/img/icons/shield-security-icon-orange.png
/* harmony default export */ var shield_security_icon_orange = ({"src":"/_next/static/media/shield-security-icon-orange.a9ef44f9.png","height":40,"width":40,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAG1BMVEX0UyPyUCPwUCPuTyHwTiPyUCLwTSPyVST0USSrda1tAAAACXRSTlMCOW8bh18qFaCX7sCZAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAMUlEQVR4nB3LuREAIBDDQPmBo/+KGchWgQDZAqgT9zUSFlqcw/qwH1JmaEDdu3+LHbgRuACJBIyMTwAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./public/img/icons/wallet-icon-orange.png
/* harmony default export */ var wallet_icon_orange = ({"src":"/_next/static/media/wallet-icon-orange.6ff9f52a.png","height":40,"width":40,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAIVBMVEX/VB7xTyPvTyLvTyLzUSTvUCLuUibwTiPwTyLxTyTtTSOHfPLkAAAAC3RSTlMCcoheHGYTe5w4SNjV7ccAAAAJcEhZcwAACxMAAAsTAQCanBgAAAA0SURBVHicLYvJCQAwEISc2SNH/wWHhfgSQYBQM1h3N6RdZSc6U2OhBGp/OV5EdCZVM0sKHhexAKxVbtLCAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./public/img/icons/brake-icon-orange.png
/* harmony default export */ var brake_icon_orange = ({"src":"/_next/static/media/brake-icon-orange.584b5465.png","height":42,"width":42,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAHlBMVEXuUCPwUCPAYiLvTyLvTiLtTibvUCPvUCL4WCfuTyKH3ne9AAAACnRSTlM8KAGFlBxXTAhvN6sEBgAAAAlwSFlzAAALEwAACxMBAJqcGAAAADVJREFUeJwdyMkNwEAMA7GRJR/bf8MBwiep6pm54tBq34HkaAc6tvWAOP7HidSIo5uiBHD1ASJUANap7xOCAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./public/img/icons/smiley-icon-orange.png
/* harmony default export */ var smiley_icon_orange = ({"src":"/_next/static/media/smiley-icon-orange.906e6c87.png","height":40,"width":40,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAHlBMVEXwUCPzUCTvTiPyUCP/VQDvUCNMaXHuTiLuTSPtTyLwjzBzAAAACnRSTlMURYZRASUAOzFvKAUTNwAAAAlwSFlzAAALEwAACxMBAJqcGAAAADNJREFUeJxFy7ERwDAMA7EXKcry/gu7yqUH6KGKaebI1hkQ3QjKm6yLcpK4QHvvih9//QEfFADlRe9czwAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./src/components/ViocPage/WhyInspectionSection.tsx









var REASON_ICONS = [
    shield_security_icon_orange,
    wallet_icon_orange,
    brake_icon_orange,
    smiley_icon_orange
];
var defaultReasons = [
    {
        title: "SAFETY",
        description: "Protect yourself and your loved ones. Faulty brakes risk accidents and lives."
    },
    {
        title: "COST SAVINGS",
        description: "Spot early wear with regular checks, saving costly future repairs."
    },
    {
        title: "PERFORMANCE",
        description: "Good brakes mean better handling, even in emergencies."
    },
    {
        title: "PEACE OF MIND",
        description: "Drive confidently, knowing your brakes won't let you down."
    }, 
];
var WhyInspectionSection = function(param) {
    var title = param.title, description = param.description, reasonsProp = param.reasons;
    var reasons = reasonsProp !== null && reasonsProp !== void 0 ? reasonsProp : defaultReasons;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(GraySection/* GraySection */.g, {
        className: "xl:py-20 text-center",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* Container */.W, {
            className: "max-w-screen-lg",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                            className: "title text-2xl sm:text-3xl md:text-4xl",
                            children: title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "description",
                            children: description
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "grid gap-4 md:grid-cols-2",
                    children: reasons.map(function(item, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(WhyInspectionItem, {
                            title: item.title,
                            description: item.description,
                            iconSource: REASON_ICONS[index]
                        }, index);
                    })
                })
            ]
        })
    });
};
var WhyInspectionItem = function(param) {
    var title = param.title, description = param.description, iconSource = param.iconSource;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "py-6 bg-white flex flex-grow-1 flex-col text-left px-6",
        style: {
            border: "1px solid #dddddd"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "bg-[#F04F231A] w-[88px] h-[88px] flex flex-row rounded-full items-center justify-center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    src: iconSource,
                    alt: "shield security icon"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "mt-3",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                        className: "text-xl",
                        children: title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "description text-base mb-0 pb-0",
                        children: description
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./public/img/icons/brake-icon-black.png
var brake_icon_black = __webpack_require__(61835);
// EXTERNAL MODULE: ./public/img/icons/receipt-discount-icon-black.png
var receipt_discount_icon_black = __webpack_require__(82705);
// EXTERNAL MODULE: ./public/img/icons/clock-icon-black.png
var clock_icon_black = __webpack_require__(13158);
// EXTERNAL MODULE: ./public/img/icons/document-icon-black.png
var document_icon_black = __webpack_require__(38177);
// EXTERNAL MODULE: ./public/img/icons/like-shaped-icon-black.png
var like_shaped_icon_black = __webpack_require__(29001);
// EXTERNAL MODULE: ./public/img/icons/shield-tick-icon-black.png
var shield_tick_icon_black = __webpack_require__(80734);
;// CONCATENATED MODULE: ./src/components/ViocPage/IncludedWithInspectionSection.tsx











var ITEM_ICONS = [
    brake_icon_black/* default */.Z,
    receipt_discount_icon_black/* default */.Z,
    clock_icon_black/* default */.Z,
    document_icon_black/* default */.Z,
    like_shaped_icon_black/* default */.Z,
    shield_tick_icon_black/* default */.Z
];
var defaultItems = [
    {
        title: "FREE ($79 Value)",
        description: "Brake Inspection"
    },
    {
        title: "UP TO $50 OFF",
        description: "Any Future Repair"
    },
    {
        title: "20 MINS",
        description: "To Complete Inspection"
    },
    {
        title: "DIGITAL INSPECTION",
        description: "Detailed Brake Report"
    },
    {
        title: "100%",
        description: "Satisfaction Guarantee"
    },
    {
        title: "2 YEAR / 24,000",
        description: "MILE Warranty"
    }, 
];
var IncludedWithInspectionSection = function(param) {
    var title = param.title, description = param.description, itemsProp = param.items;
    var items = itemsProp !== null && itemsProp !== void 0 ? itemsProp : defaultItems;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(GraySection/* GraySection */.g, {
        className: "pt-[5%] xl:py-20 text-center",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* Container */.W, {
            className: "max-w-screen-lg",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                            className: "title text-2xl sm:text-3xl md:text-4xl",
                            children: title
                        }),
                        description && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "description text-black",
                            children: description
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "mt-8 grid gap-4 md:grid-cols-2 lg:grid-cols-3",
                    children: items.map(function(item, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(IncludedWithInspectionItem, {
                            title: item.title,
                            description: item.description,
                            iconSource: ITEM_ICONS[index]
                        }, index);
                    })
                })
            ]
        })
    });
};
var IncludedWithInspectionItem = function(param) {
    var title = param.title, description = param.description, iconSource = param.iconSource;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "py-4 bg-white flex flex-col items-center justify-center text-center px-6",
        style: {
            border: "1px solid #dddddd"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "w-[60px] h-[60px] flex flex-row rounded-full items-center justify-center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    src: iconSource,
                    height: 40,
                    width: 40,
                    alt: "shield security icon"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "mt-3",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                        className: "text-lg text-primary",
                        children: title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "description text-black",
                        children: description
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./public/img/tech-greeting-customer.png
/* harmony default export */ var tech_greeting_customer = ({"src":"/_next/static/media/tech-greeting-customer.aabafbe4.png","height":820,"width":1024,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAGCAMAAADJ2y/JAAAAZlBMVEWDioqRfE1NRT9ONyuXmpucjGt9c2l/j5mhnJB1bGHeoYmWj4J6enNeZ2qIeWl5YEuMdDqDcEKJhXWShGeqp5yOjoxtb2iLoa94e4CMnaeQcWNdWE7HqJc6NTKJVD+1OAqihkr/lGcgNkUqAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAOklEQVR4nAXBhQGAMBAAsat+BSjuuv+SJMjKArWwiZ3mEC3ZH7oafUM6s3Z9LHxpN0oNgee+zNt27gc8jgJ7Xlr0CQAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":6});
;// CONCATENATED MODULE: ./src/components/ViocPage/NotYourTypicalProviderSection.tsx









var NotYourTypicalProviderSection_defaultItems = [
    "Free inspection, completed in 20 minutes",
    "Let us come to you or meet us at a Valvoline location",
    "Premium parts backed by 2-year / 24,000-mile warranty",
    "Only recommending repairs you actually need", 
];
var NotYourTypicalProviderSection = function(param) {
    var _title = param.title, title = _title === void 0 ? "Not Your Typical Service Provider — Local & Convenient" : _title, _description = param.description, description = _description === void 0 ? "We offer brake service at home or at select Valvoline locations (by appointment only). High-quality parts, no upsells — just what you need, where you need it" : _description, _items = param.items, items = _items === void 0 ? NotYourTypicalProviderSection_defaultItems : _items, _buttonText = param.buttonText, buttonText = _buttonText === void 0 ? "GET A FREE INSPECTION & QUOTE" : _buttonText;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(GraySection/* GraySection */.g, {
        className: "py-[5%] xl:py-16 text-center",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* Container */.W, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-col gap-12 lg:flex-row items-center justify-center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-col text-left",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                        className: "title text-2xl sm:text-3xl md:text-4xl",
                                        children: title
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "description",
                                        children: description
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "flex flex-col",
                                children: items.map(function(item) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: " flex flex-row justify-start items-center",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                                icon: free_solid_svg_icons/* faCheckCircle */.f8k,
                                                size: "1x",
                                                color: "#14d90d",
                                                style: {
                                                    borderRadius: "100%",
                                                    backgroundColor: "white"
                                                }
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "ml-2 mt-1 text-black",
                                                children: item
                                            })
                                        ]
                                    }, item);
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "pt-5",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CtaButton, {
                                    className: "w-full lg:w-fit",
                                    buttonText: buttonText,
                                    href: "#"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "w-full max-w-[28rem] max-h-[28rem] lg:max-w-[32rem] lg:max-h-[32rem] relative ",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            sizes: "w-full h-auto",
                            objectFit: "cover",
                            width: 1024,
                            height: 820,
                            src: tech_greeting_customer
                        })
                    })
                ]
            })
        })
    });
};

// EXTERNAL MODULE: ./node_modules/react-animate-height/lib/AnimateHeight.js
var AnimateHeight = __webpack_require__(68133);
;// CONCATENATED MODULE: ./src/components/ViocPage/FAQSection.tsx









var faqsItems = [
    {
        question: "IS THE INSPECTION REALLY FREE?",
        answer: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "Yes! Whether you meet us at home or at one of our partner locations, the inspection is always 100% free and comes with no obligation."
            })
        })
    },
    {
        question: "DO I HAVE TO GET MY BRAKES REPAIRED WHEN YOU COME OUT?",
        answer: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "Not at all. You’ll receive a full inspection and a no-obligation quote. If service is needed, you can choose to book a mobile repair or return to our partner location by appointment."
            })
        })
    },
    {
        question: "DOES NUBRAKES OFFER A WARRANTY?",
        answer: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                    children: [
                        "Yes, all of our repairs are backed by our",
                        " ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: {
                                pathname: "/warranty"
                            },
                            target: "_blank",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                target: "_blank",
                                children: "24 month, 24,000 mile warranty"
                            })
                        }),
                        "."
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    children: "We’re committed to providing a transparent, affordable and ultra-convenient brake repair experience, and we stand behind our work."
                })
            ]
        })
    },
    {
        question: "HOW LONG DOES IT TAKE?",
        answer: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    children: "Your brake inspection will take about 20 minutes to complete. "
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    children: "A brake repair service will take about 60 minutes to complete. "
                })
            ]
        })
    },
    {
        question: "WHO ARE NUBRAKES' TECHNICIANS?",
        answer: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "Our full-time technicians are experienced professionals with deep expertise in brake systems. They perform inspections and repairs at homes, workplaces, or partner locations, depending on customer preference."
            })
        })
    },
    {
        question: "WHAT TYPE OF PARTS DOES NUBRAKES USE?",
        answer: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    children: "High-quality parts are of the utmost importance when repairing your brakes."
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    children: "At NuBrakes, most frequently we use professional ceramic or semi-metallic brake pads that are equivalent or better than OEM-recommended parts."
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                    children: [
                        "These parts offer exceptional performance and are backed by our",
                        " ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: {
                                pathname: "/warranty"
                            },
                            target: "_blank",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                target: "_blank",
                                children: "24 month, 24,000 mile warranty"
                            })
                        }),
                        "."
                    ]
                })
            ]
        })
    },
    {
        question: "Can I Visit NuBrakes in Person?",
        answer: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "We have trained NuBrakes representatives based inside select Valvoline Instant Oil Change locations where you can schedule an inspection or consultation. You’ll see NuBrakes signage on the building and our entrance — or you can book a mobile visit online at a location of your choice."
            })
        })
    }, 
];
var FAQSection = function(param) {
    var title = param.title, description = param.description, _faqs = param.faqs, faqs = _faqs === void 0 ? faqsItems : _faqs;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(GraySection/* GraySection */.g, {
        className: "xl:py-20 text-center",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* Container */.W, {
            className: "max-w-screen-lg",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                    className: "title text-2xl sm:text-3xl md:text-4xl",
                    children: title
                }),
                description ? /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "description",
                    children: description
                }) : null,
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "grid mt-8 gap-4",
                    children: faqs.map(function(value, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(FAQ, {
                            question: value.question,
                            children: value.answer
                        }, index);
                    })
                })
            ]
        })
    });
};
var FAQ = function(param) {
    var question = param.question, children = param.children;
    var ref = (0,_sliced_to_array/* default */.Z)(react.useState(false), 2), isOpen = ref[0], setIsOpen = ref[1];
    var height = isOpen ? "auto" : 0;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "flex flex-col flex-grow rounded-md bg-white border ".concat(isOpen ? "border-[#f04e23]" : "border-gray-200"),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "text-left",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "rounded-md px-4 py-3 h-100",
                        style: {
                            cursor: "pointer"
                        },
                        onClick: function() {
                            return setIsOpen(!isOpen);
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex items-center",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "mb-0 mr-2",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                        style: {
                                            fontFamily: "IndustryInc-Base",
                                            fontSize: 14
                                        },
                                        children: question
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "flex ml-auto",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                        icon: isOpen ? free_solid_svg_icons/* faChevronUp */.mTx : free_solid_svg_icons/* faChevronDown */.ptq,
                                        className: "mx-1",
                                        size: "sm",
                                        color: "#f04e23"
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AnimateHeight/* default */.Z, {
                        duration: 350,
                        height: height,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: " py-4",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "description text-base px-3",
                                    children: children
                                })
                            })
                        })
                    })
                ]
            })
        })
    });
};

// EXTERNAL MODULE: ./node_modules/react-responsive-carousel/lib/js/index.js
var js = __webpack_require__(10615);
;// CONCATENATED MODULE: ./src/components/ViocPage/ReviewsSection.tsx










var ReviewsSection = function(param) {
    var first = param.first, second = param.second, third = param.third, title = param.title, _partnerLabel = param.partnerLabel, partnerLabel = _partnerLabel === void 0 ? "PREFERRED BRAKE PARTNER" : _partnerLabel, _reviewCountLabel = param.reviewCountLabel, reviewCountLabel = _reviewCountLabel === void 0 ? "(14,270 reviews)" : _reviewCountLabel;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(GraySection/* GraySection */.g, {
        className: "xl:py-20",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* Container */.W, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex items-center justify-center mb-6",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: vioc_logo/* default */.Z,
                            width: 50,
                            height: 45.56,
                            objectPosition: "bottom center",
                            priority: true,
                            alt: "Valvoline logo"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "ml-4 text-sm lg:text-base",
                            style: {
                                fontFamily: "IndustryInc-Base"
                            },
                            children: partnerLabel
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "text-center pb-5",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                            className: "title text-2xl sm:text-3xl md:text-4xl",
                            children: title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex mt-4 justify-center items-center text-black flex-wrap",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "mr-3",
                                    style: {
                                        fontFamily: "IndustryInc-Base"
                                    },
                                    children: "4.9"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(StarsAndRatings, {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex ml-3 items-center",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            children: reviewCountLabel
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "ml-2 flex items-center justify-center w-5 h-5 rounded-full",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                src: google_logo_icon/* default */.Z,
                                                objectPosition: "bottom center",
                                                priority: true,
                                                alt: "Valvoline logo"
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "md:hidden",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(js/* Carousel */.lr, {
                        showThumbs: false,
                        showStatus: false,
                        showArrows: false,
                        autoPlay: true,
                        infiniteLoop: true,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(V2Review, (0,_object_spread/* default */.Z)({}, first)),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(V2Review, (0,_object_spread/* default */.Z)({}, second)),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(V2Review, (0,_object_spread/* default */.Z)({}, third))
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "hidden md:grid md:grid-cols-3 gap-4",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(V2Review, (0,_object_spread/* default */.Z)({}, first))
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(V2Review, (0,_object_spread/* default */.Z)({}, second))
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(V2Review, (0,_object_spread/* default */.Z)({}, third))
                        })
                    ]
                })
            ]
        })
    });
};
var V2Review = function(param) {
    var review = param.review, reviewer = param.reviewer;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        style: {
            marginBottom: 40
        },
        className: "flex flex-col h-100",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            style: {
                border: "1px solid #dcdbdb"
            },
            className: "flex flex-col px-4 py-5 h-100 bg-white",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    children: '"'.concat(review, '"')
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex w-full items-center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            style: {
                                fontFamily: "IndustryInc-Base"
                            },
                            className: "reviewer my-auto text-sm leading-none pr-3 mr-auto",
                            children: reviewer
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StarsAndRatings, {})
                    ]
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./src/components/ViocPage/viocCopy.tsx
var viocCopy = __webpack_require__(82011);
;// CONCATENATED MODULE: ./src/components/ViocPage/index.tsx


























var ViocIndexPageTemplate = function(param) {
    var phoneNumber = param.phoneNumber, phoneNumberTxt = param.phoneNumberTxt, rating = param.rating, reviewCount = param.reviewCount, copyProp = param.copy;
    var copy = copyProp !== null && copyProp !== void 0 ? copyProp : (0,viocCopy/* getViocCopy */.ak)("en");
    var layoutLocale = copy === viocCopy/* viocCopyEs */.wY ? "es" : "en";
    // Show sticky CTA once the user scrolls past the header fold
    var headerRef = (0,react.useRef)(null);
    var ref = (0,react.useState)(false), showStickyBar = ref[0], setShowStickyBar = ref[1];
    (0,react.useEffect)(function() {
        var el = headerRef.current;
        if (!el) return;
        var observer = new IntersectionObserver(function(param) {
            var _param = (0,_sliced_to_array/* default */.Z)(param, 1), entry = _param[0];
            return setShowStickyBar(!entry.isIntersecting);
        }, {
            threshold: 0
        });
        observer.observe(el);
        return function() {
            return observer.disconnect();
        };
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Layout/* default */.Z, {
        navBarVariant: "simple",
        showFooter: false,
        showGetQuote: false,
        phoneNumber: phoneNumber,
        phoneNumberTxt: phoneNumberTxt,
        title: copy.meta.title,
        locale: layoutLocale,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "description",
                        content: copy.meta.description
                    }, "description"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "robots",
                        content: "noindex,nofollow"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                ref: headerRef,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ViocPage_HeaderSection, {
                    rating: rating,
                    formInitialProps: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, NoEmailScheduleServiceFormMultiStep/* twDefaultInitialWizardFormValues */.oA), {
                        "form-name": "semScheduleServiceForm"
                    }),
                    reviewCount: reviewCount,
                    title: copy.header.title,
                    subtitle: copy.header.subtitle,
                    bullets: copy.header.bullets,
                    placeholder: copy.header.placeholder,
                    scheduleButton: copy.header.scheduleButton,
                    reviewsLabel: copy.header.reviewsLabel
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "bg-gray-100",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "pt-10 w-full max-w-[700px] mx-auto px-5",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("iframe", {
                        className: "w-full aspect-video",
                        src: "https://www.youtube.com/embed/qot_8qfLxTQ?si=s2W2uVjJUkZ_Wg1m",
                        allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share",
                        referrerPolicy: "strict-origin-when-cross-origin",
                        allowFullScreen: true
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(WhyInspectionSection, {
                title: copy.whyInspection.title,
                description: copy.whyInspection.description,
                reasons: copy.whyInspection.reasons
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(IncludedWithInspectionSection, {
                title: copy.includedWithInspection.title,
                description: copy.includedWithInspection.description,
                items: copy.includedWithInspection.items
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ServicesHowItWorksSection, {
                title: copy.howItWorks.title,
                steps: copy.howItWorks.steps.map(function(step, i) {
                    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, step), {
                        image: [
                            faMoneyCheckEditAlt/* faMoneyCheckEditAlt */.v4,
                            faCalendarCheck/* faCalendarCheck */.Ry,
                            faCarMechanic/* faCarMechanic */.cC
                        ][i]
                    });
                }),
                buttonText: copy.howItWorks.buttonText
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ReviewsSection, {
                title: copy.reviews.title,
                partnerLabel: copy.reviews.partnerLabel,
                reviewCountLabel: copy.reviews.reviewCountLabel,
                first: copy.reviews.first,
                second: copy.reviews.second,
                third: copy.reviews.third
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(NotYourTypicalProviderSection, {
                title: copy.notYourTypical.title,
                description: copy.notYourTypical.description,
                items: copy.notYourTypical.items,
                buttonText: copy.notYourTypical.buttonText
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FAQSection, {
                title: copy.faq.title,
                faqs: copy.faq.faqs
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HappinessGuaranteeSection, {
                title: copy.happiness.title,
                description: copy.happiness.description
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(GraySection/* GraySection */.g, {
                className: "xl:py-20",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "flex w-full justify-center",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CtaButton, {
                        href: "#",
                        className: "w-full lg:w-fit",
                        buttonText: copy.ctaButton
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                style: {
                    position: "fixed",
                    bottom: 0,
                    left: 0,
                    right: 0,
                    zIndex: 50,
                    transform: showStickyBar ? "translateY(0)" : "translateY(100%)",
                    transition: "transform 0.3s ease-in-out"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "bg-white border-t border-gray-200 shadow-lg px-4 py-3 flex justify-center",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CtaButton, {
                        href: "#",
                        className: "w-full max-w-sm",
                        buttonText: copy.ctaButton
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LeadExtraFields/* LeadExtraFields */.V, {})
        ]
    });
};
var ViocPage = function(param) {
    var _rating = param.rating, rating = _rating === void 0 ? "4.94" : _rating, _reviewCount = param.reviewCount, reviewCount = _reviewCount === void 0 ? 6013 : _reviewCount;
    var phoneNumber = CityPhoneNumberData/* CityPhoneNumberData.generalValvoline.phoneNumber */.L.generalValvoline.phoneNumber;
    var phoneNumberTxt = (0,string_utils/* formatPhoneNumber */.u)(phoneNumber);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ViocIndexPageTemplate, {
        rating: rating,
        reviewCount: reviewCount,
        phoneNumberTxt: phoneNumberTxt,
        phoneNumber: phoneNumber
    });
};
/* harmony default export */ var components_ViocPage = (ViocPage);


/***/ }),

/***/ 82011:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ak": function() { return /* binding */ getViocCopy; },
/* harmony export */   "wY": function() { return /* binding */ viocCopyEs; }
/* harmony export */ });
/* unused harmony export viocCopyEn */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);





var warrantyLink = function(href, text) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
        href: href,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
            target: "_blank",
            rel: "noreferrer",
            children: text
        })
    });
};
var viocCopyEn = {
    meta: {
        title: "NuBrakes Mobile Brake Repair",
        description: "Drive safely with confidence. Schedule your free brake inspection with NuBrakes."
    },
    header: {
        subtitle: "Preferred Brake Partner",
        title: "SCHEDULE YOUR FREE BRAKE INSPECTION",
        bullets: [
            "We come to you — or meet at Valvoline",
            "Free Brake Inspection ($79 Value)",
            "Completed in 20 minutes", 
        ],
        placeholder: "Enter your Phone Number here",
        scheduleButton: "SCHEDULE INSPECTION",
        reviewsLabel: "(14,270 reviews)"
    },
    whyInspection: {
        title: "WHY YOU SHOULD GET A BRAKE INSPECTION",
        description: "Getting your brakes inspected is essential — we make it easy at home, work, or a Valvoline location.",
        reasons: [
            {
                title: "SAFETY",
                description: "Protect yourself and your loved ones. Faulty brakes risk accidents and lives."
            },
            {
                title: "COST SAVINGS",
                description: "Spot early wear with regular checks, saving costly future repairs."
            },
            {
                title: "PERFORMANCE",
                description: "Good brakes mean better handling, even in emergencies."
            },
            {
                title: "PEACE OF MIND",
                description: "Drive confidently, knowing your brakes won't let you down."
            }, 
        ]
    },
    includedWithInspection: {
        title: " Included With Your Free (20-Minute) Brake Inspection — At Home or On-Site",
        description: "We'll come to you, or you can meet us at a Valvoline location by appointment.",
        items: [
            {
                title: "FREE ($79 Value)",
                description: "Brake Inspection"
            },
            {
                title: "UP TO $50 OFF",
                description: "Any Future Repair"
            },
            {
                title: "20 MINS",
                description: "To Complete Inspection"
            },
            {
                title: "DIGITAL INSPECTION",
                description: "Detailed Brake Report"
            },
            {
                title: "100%",
                description: "Satisfaction Guarantee"
            },
            {
                title: "2 YEAR / 24,000",
                description: "MILE Warranty"
            }, 
        ]
    },
    howItWorks: {
        title: "How It Works – In Person or At Your Door",
        steps: [
            {
                title: "FREE INSPECTION — AT YOUR HOME OR OUR PARTNER LOCATION",
                description: "We'll inspect your brakes at your convenience and provide a no-obligation repair timeline and quote."
            },
            {
                title: "CHOOSE YOUR PREFERRED REPAIR LOCATION",
                description: "Need service? We'll come to you or meet you again at one of our partnered locations — 7 days a week."
            },
            {
                title: "GET BACK ON THE ROAD WITH CONFIDENCE",
                description: "Same great service, wherever you are. No waiting rooms. No pressure. Just safe, reliable brake repair."
            }, 
        ],
        buttonText: "GET A FREE INSPECTION & QUOTE"
    },
    reviews: {
        partnerLabel: "PREFERRED BRAKE PARTNER",
        title: "WHY CUSTOMERS LOVE NUBRAKES",
        reviewCountLabel: "(14,270 reviews)",
        first: {
            review: "We received fantastic, quick service, at a fair price. We got quite a few quotes and NuBrakes was the best price and it turns out, the quickest and best service. Our technician, Mike, was knowledgeable and friendly and got the job done quickly - all at my office. We would definitely recommend them and use the service again.",
            reviewer: "Tami F."
        },
        second: {
            reviewer: "Clinton B.",
            review: "This service is awesome. You are paying for fast, convenient and good quality work. Communication with Walker was immediate and the technician Micheal was done in half the time that was quoted. I will use NuBrakes again in the future and recommend it to everyone. I mean, they come to you, that was what sold it for me."
        },
        third: {
            review: "Without a doubt would recommend NuBrakes to anyone that needs brakes done. Service tech showed up on time and was professional and quick. And the conveniences having them come to you is hard to beat. Not to mention the price is close to half what you'd pay at a pep boys or any other body shop. Can't beat it.",
            reviewer: "William T."
        }
    },
    notYourTypical: {
        title: "Not Your Typical Service Provider — Local & Convenient",
        description: "We offer brake service at home or at select Valvoline locations (by appointment only). High-quality parts, no upsells — just what you need, where you need it",
        items: [
            "Free inspection, completed in 20 minutes",
            "Let us come to you or meet us at a Valvoline location",
            "Premium parts backed by 2-year / 24,000-mile warranty",
            "Only recommending repairs you actually need", 
        ],
        buttonText: "GET A FREE INSPECTION & QUOTE"
    },
    faq: {
        title: "HAVE A QUESTION? GET IT ANSWERED",
        faqs: []
    },
    happiness: {
        title: "",
        description: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {})
    },
    ctaButton: "SCHEDULE FREE INSPECTION"
};
var faqsEn = [
    {
        question: "IS THE INSPECTION REALLY FREE?",
        answer: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                children: "Yes! Whether you meet us at home or at one of our partner locations, the inspection is always 100% free and comes with no obligation."
            })
        })
    },
    {
        question: "DO I HAVE TO GET MY BRAKES REPAIRED WHEN YOU COME OUT?",
        answer: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                children: "Not at all. You'll receive a full inspection and a no-obligation quote. If service is needed, you can choose to book a mobile repair or return to our partner location by appointment."
            })
        })
    },
    {
        question: "DOES NUBRAKES OFFER A WARRANTY?",
        answer: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                    children: [
                        "Yes, all of our repairs are backed by our ",
                        warrantyLink("/warranty", "24 month, 24,000 mile warranty"),
                        "."
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    children: "We're committed to providing a transparent, affordable and ultra-convenient brake repair experience, and we stand behind our work."
                })
            ]
        })
    },
    {
        question: "HOW LONG DOES IT TAKE?",
        answer: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    children: "Your brake inspection will take about 20 minutes to complete."
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    children: "A brake repair service will take about 60 minutes to complete."
                })
            ]
        })
    },
    {
        question: "WHO ARE NUBRAKES' TECHNICIANS?",
        answer: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                children: "Our full-time technicians are experienced professionals with deep expertise in brake systems. They perform inspections and repairs at homes, workplaces, or partner locations, depending on customer preference."
            })
        })
    },
    {
        question: "WHAT TYPE OF PARTS DOES NUBRAKES USE?",
        answer: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    children: "High-quality parts are of the utmost importance when repairing your brakes."
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    children: "At NuBrakes, most frequently we use professional ceramic or semi-metallic brake pads that are equivalent or better than OEM-recommended parts."
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                    children: [
                        "These parts offer exceptional performance and are backed by our",
                        " ",
                        warrantyLink("/warranty", "24 month, 24,000 mile warranty"),
                        "."
                    ]
                })
            ]
        })
    },
    {
        question: "Can I Visit NuBrakes in Person?",
        answer: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                children: "We have trained NuBrakes representatives based inside select Valvoline Instant Oil Change locations where you can schedule an inspection or consultation. You'll see NuBrakes signage on the building and our entrance — or you can book a mobile visit online at a location of your choice."
            })
        })
    }, 
];
var faqsEs = [
    {
        question: "\xbfLA INSPECCI\xd3N ES REALMENTE GRATIS?",
        answer: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                children: "\xa1S\xed! Ya sea en tu casa o en una de nuestras ubicaciones asociadas, la inspecci\xf3n siempre es 100% gratis y sin compromiso."
            })
        })
    },
    {
        question: "\xbfTENGO QUE REPARAR LOS FRENOS CUANDO VENGAN?",
        answer: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                children: "Para nada. Recibir\xe1s una inspecci\xf3n completa y un presupuesto sin compromiso. Si necesitas servicio, puedes agendar una reparaci\xf3n m\xf3vil o volver a nuestra ubicaci\xf3n asociada con cita."
            })
        })
    },
    {
        question: "\xbfNUBRAKES OFRECE GARANT\xcdA?",
        answer: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                    children: [
                        "S\xed, todas nuestras reparaciones tienen la ",
                        warrantyLink("/warranty", "garant\xeda de 24 meses o 24,000 millas"),
                        "."
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    children: "Estamos comprometidos a ofrecer una experiencia de reparaci\xf3n de frenos transparente, econ\xf3mica y muy conveniente, y respaldamos nuestro trabajo."
                })
            ]
        })
    },
    {
        question: "\xbfCU\xc1NTO TARDA?",
        answer: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    children: "La inspecci\xf3n de frenos tarda aproximadamente 20 minutos."
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    children: "El servicio de reparaci\xf3n de frenos tarda aproximadamente 60 minutos."
                })
            ]
        })
    },
    {
        question: "\xbfQUI\xc9NES SON LOS T\xc9CNICOS DE NUBRAKES?",
        answer: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                children: "Nuestros t\xe9cnicos de tiempo completo son profesionales con amplia experiencia en sistemas de frenos. Realizan inspecciones y reparaciones en hogares, lugares de trabajo o ubicaciones asociadas, seg\xfan la preferencia del cliente."
            })
        })
    },
    {
        question: "\xbfQU\xc9 TIPO DE PIEZAS USA NUBRAKES?",
        answer: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    children: "Las piezas de alta calidad son fundamentales al reparar tus frenos."
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    children: "En NuBrakes usamos con frecuencia pastillas de freno cer\xe1micas o semi-met\xe1licas profesionales equivalentes o superiores a las piezas recomendadas por el fabricante."
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                    children: [
                        "Estas piezas ofrecen un rendimiento excepcional y est\xe1n respaldadas por nuestra",
                        " ",
                        warrantyLink("/warranty", "garant\xeda de 24 meses o 24,000 millas"),
                        "."
                    ]
                })
            ]
        })
    },
    {
        question: "\xbfPuedo visitar NuBrakes en persona?",
        answer: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                children: "Tenemos representantes de NuBrakes en selectas ubicaciones de Valvoline Instant Oil Change donde puedes agendar una inspecci\xf3n o consulta. Ver\xe1s la se\xf1alizaci\xf3n de NuBrakes en el edificio y en nuestra entrada, o puedes reservar una visita m\xf3vil en l\xednea en la ubicaci\xf3n de tu preferencia."
            })
        })
    }, 
];
viocCopyEn.faq = {
    title: "HAVE A QUESTION? GET IT ANSWERED",
    faqs: faqsEn
};
viocCopyEn.happiness = {
    title: "Happiness Guaranteed",
    description: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            "Our brake techs have decades of combined experience, and all services are backed by our",
            " ",
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                href: "/warranty",
                children: "NuBrakes Guarantee"
            }),
            "."
        ]
    })
};

var viocCopyEs = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, viocCopyEn), {
    meta: {
        title: "NuBrakes Reparaci\xf3n de Frenos M\xf3vil",
        description: "Conduce con seguridad y confianza. Agenda tu inspecci\xf3n de frenos gratis con NuBrakes."
    },
    header: {
        subtitle: "Socio Preferido de Frenos",
        title: "AGENDA TU INSPECCI\xd3N DE FRENOS GRATIS",
        bullets: [
            "Vamos a ti — o nos vemos en Valvoline",
            "Inspecci\xf3n de frenos gratis (valor $79)",
            "Hecha en 20 minutos", 
        ],
        placeholder: "Ingresa tu n\xfamero de tel\xe9fono",
        scheduleButton: "AGENDAR INSPECCI\xd3N",
        reviewsLabel: "(14,270 rese\xf1as)"
    },
    whyInspection: {
        title: "POR QU\xc9 DEBER\xcdAS HACERTE UNA INSPECCI\xd3N DE FRENOS",
        description: "Inspeccionar tus frenos es esencial; nosotros lo hacemos f\xe1cil en casa, en el trabajo o en una ubicaci\xf3n Valvoline.",
        reasons: [
            {
                title: "SEGURIDAD",
                description: "Protege tu vida y la de los tuyos. Los frenos en mal estado ponen en riesgo accidentes y vidas."
            },
            {
                title: "AHORRO",
                description: "Detecta el desgaste a tiempo con revisiones regulares y evita reparaciones costosas."
            },
            {
                title: "RENDIMIENTO",
                description: "Unos buenos frenos significan mejor control, incluso en emergencias."
            },
            {
                title: "TRANQUILIDAD",
                description: "Conduce con confianza sabiendo que tus frenos no te fallar\xe1n."
            }, 
        ]
    },
    includedWithInspection: {
        title: " Incluido con tu inspecci\xf3n de frenos gratis",
        description: "Vamos a ti o puedes ir a una ubicaci\xf3n Valvoline (con cita previa).",
        items: [
            {
                title: "GRATIS (valor $79)",
                description: "Inspecci\xf3n de frenos"
            },
            {
                title: "HASTA $50 DE DESCUENTO",
                description: "En cualquier reparaci\xf3n futura"
            },
            {
                title: "20 MIN",
                description: "Para completar la inspecci\xf3n"
            },
            {
                title: "INSPECCI\xd3N DIGITAL",
                description: "Reporte detallado de frenos"
            },
            {
                title: "100%",
                description: "Garant\xeda de satisfacci\xf3n"
            },
            {
                title: "2 A\xd1OS / 24,000",
                description: "MILLAS de garant\xeda"
            }, 
        ]
    },
    howItWorks: {
        title: "C\xf3mo funciona — en persona o en tu casa",
        steps: [
            {
                title: "INSPECCI\xd3N GRATIS — EN TU CASA O UBICACI\xd3N ASOCIADA",
                description: "Inspeccionamos tus frenos cuando te convenga y te damos un plazo y presupuesto de reparaci\xf3n sin compromiso."
            },
            {
                title: "ELIGE TU UBICACI\xd3N PREFERIDA PARA LA REPARACI\xd3N",
                description: "\xbfNecesitas servicio? Vamos a ti o te esperamos en una de nuestras ubicaciones asociadas — 7 d\xedas a la semana."
            },
            {
                title: "VUELVE A LA CARRETERA CON CONFIANZA",
                description: "El mismo gran servicio, donde sea que est\xe9s. Sin salas de espera. Sin presi\xf3n. Solo reparaci\xf3n de frenos segura y confiable."
            }, 
        ],
        buttonText: "OBTENER INSPECCI\xd3N Y PRESUPUESTO GRATIS"
    },
    reviews: {
        partnerLabel: "SOCIO PREFERIDO DE FRENOS",
        title: "POR QU\xc9 LOS CLIENTES AMAN NUBRAKES",
        reviewCountLabel: "(14,270 rese\xf1as)",
        first: {
            review: "Recibimos un servicio fant\xe1stico y r\xe1pido a un precio justo. Obtuvimos varias cotizaciones y NuBrakes fue el mejor precio y result\xf3 ser el servicio m\xe1s r\xe1pido y mejor. Nuestro t\xe9cnico, Mike, fue conocedor y amable e hizo el trabajo r\xe1pidamente, todo en mi oficina. Sin duda los recomendar\xedamos y usar\xedamos el servicio de nuevo.",
            reviewer: "Tami F."
        },
        second: {
            reviewer: "Clinton B.",
            review: "Este servicio es incre\xedble. Pagas por trabajo r\xe1pido, conveniente y de buena calidad. La comunicaci\xf3n con Walker fue inmediata y el t\xe9cnico Michael termin\xf3 en la mitad del tiempo cotizado. Usar\xe9 NuBrakes de nuevo en el futuro y lo recomiendo a todos. Vienen a ti, eso fue lo que me convenci\xf3."
        },
        third: {
            review: "Sin duda recomendar\xeda NuBrakes a cualquiera que necesite frenos. El t\xe9cnico lleg\xf3 a tiempo, fue profesional y r\xe1pido. Y la comodidad de que vengan a ti no tiene precio. Por no mencionar que el precio es casi la mitad de lo que pagar\xedas en Pep Boys u otro taller. Inigualable.",
            reviewer: "William T."
        }
    },
    notYourTypical: {
        title: "No somos un proveedor cualquiera — local y conveniente",
        description: "Ofrecemos servicio de frenos en casa o en ubicaciones selectas de Valvoline (solo con cita). Piezas de alta calidad, sin ventas adicionales — solo lo que necesitas, donde lo necesitas.",
        items: [
            "Inspecci\xf3n gratis, completada en 20 minutos",
            "Vamos a ti o nos vemos en una ubicaci\xf3n Valvoline",
            "Piezas premium con garant\xeda de 2 a\xf1os / 24,000 millas",
            "Solo recomendamos las reparaciones que realmente necesitas", 
        ],
        buttonText: "OBTENER INSPECCI\xd3N Y PRESUPUESTO GRATIS"
    },
    faq: {
        title: "\xbfTIENES PREGUNTAS? TE LAS RESPONDEMOS",
        faqs: faqsEs
    },
    happiness: {
        title: "Garant\xeda de satisfacci\xf3n",
        description: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: [
                "Nuestros t\xe9cnicos tienen d\xe9cadas de experiencia combinada y todos los servicios est\xe1n respaldados por nuestra",
                " ",
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                    href: "/warranty",
                    children: "Garant\xeda NuBrakes"
                }),
                "."
            ]
        })
    },
    ctaButton: "AGENDAR INSPECCI\xd3N GRATIS"
});
function getViocCopy(locale) {
    return locale === "es" ? viocCopyEs : viocCopyEn;
}


/***/ })

}]);